export default __webpack_public_path__ + "static/media/Joot_events_web.b35d70cb.webp";